import React from 'react';
import AddendaPageContent from '../../Addendum/Components/AddendaPageContent';

export default function AddendaPage() {
    return <AddendaPageContent />;
}
